function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  stroke: "#885DF0",
  strokeWidth: 2.053
}), /*#__PURE__*/React.createElement("path", {
  fill: "#885DF0",
  stroke: "#885DF0",
  strokeWidth: 0.979,
  d: "M22.827 16c-2.948 0-5.413 2.167-5.915 5.015-2.643.238-4.722 2.465-4.722 5.204 0 2.898 2.321 5.248 5.182 5.248h11.961v-.947l-11.96-.158c-2.277 0-4.092-1.838-4.092-4.143 0-2.305 1.815-4.143 4.091-4.143a.548.548 0 0 0 .546-.5c.247-2.509 2.359-4.471 4.909-4.471 1.388 0 2.523.544 3.426 1.484a.54.54 0 0 0 .588.13c.394-.152.955-.233 1.44-.233 1.96 0 3.59 1.466 3.819 3.374.023.21.162.387.358.458 1.558.58 2.642 2.098 2.642 3.901 0 2.305-1.816 4.143-4.091 4.143l-1.676.158v.947h1.676c2.861 0 5.181-2.35 5.181-5.248a5.215 5.215 0 0 0-3.06-4.773c-.419-2.322-2.447-4.065-4.849-4.065-.494 0-1.013.083-1.5.224C25.731 16.62 24.386 16 22.827 16z"
}));

const SvgIcCvo = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCvo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-cvo.c73bdb21.svg";
export { ForwardRef as ReactComponent };